import React from 'react';

function TrashCanIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.9,2L7.2,3.1h5.7L12.1,2c-0.1-0.1-0.2-0.1-0.3-0.1H8.2C8.1,1.9,8,1.9,7.9,2L7.9,2z M13.7,1l1.4,2.1h0.5h1.9h0.3c0.5,0,0.9,0.4,0.9,0.9S18.3,5,17.8,5h-0.3v11.9c0,1.7-1.4,3.1-3.1,3.1H5.6c-1.7,0-3.1-1.4-3.1-3.1V5H2.2C1.7,5,1.2,4.6,1.2,4.1s0.4-0.9,0.9-0.9h0.3h1.9h0.5L6.3,1c0.4-0.6,1.1-1,1.8-1h3.7C12.6,0,13.2,0.4,13.7,1L13.7,1z M4.4,5v11.9c0,0.7,0.6,1.2,1.2,1.2h8.8c0.7,0,1.2-0.6,1.2-1.2V5H4.4z M7.5,7.5v8.1c0,0.3-0.3,0.6-0.6,0.6S6.2,16,6.2,15.6V7.5c0-0.3,0.3-0.6,0.6-0.6S7.5,7.2,7.5,7.5zM10.6,7.5v8.1c0,0.3-0.3,0.6-0.6,0.6S9.4,16,9.4,15.6V7.5c0-0.3,0.3-0.6,0.6-0.6S10.6,7.2,10.6,7.5z M13.8,7.5v8.1c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6V7.5c0-0.3,0.3-0.6,0.6-0.6S13.8,7.2,13.8,7.5z"/>
    </svg>
  );
}

export default TrashCanIcon;
